(function ( $ ) {

    $.fn.news = function() {
        var that = this,
            current_page = 0,
            has_more = true,
            countFinder = /<\!--COUNT:(\d+?)-->/i;

        function hideLoadMoreButton() {
            $('.js-load-more').addClass('hide');
        }
        function showLoadMoreButton() {
            $('.js-load-more').removeClass('hide');
        }

        function getNewspapers(replace) {
            var category = that.data('category');

            $.post(
                ajaxurl,
                {
                    'action': 'get_news',
                    'category': category,
                    'current_page': current_page
                },
                function(res)
                {
                    var matches = countFinder.exec(res),
                        count = parseInt(matches[1]);
                    if (count == 6) {
                        showLoadMoreButton();
                    } else {
                        hideLoadMoreButton();
                    }
                    if (replace) {
                        that.html(res);
                        current_page = 0;
                    } else {
                        that.append(res);
                    }

                    asyncImg(function(){
                        initToShow();
                    });

                    asyncBg(function(){
                        initToShow();
                        initCarousel();
                    });
                }
            );
        }

        getNewspapers(true);

        $('.js-load-more').click(function() {
            current_page = current_page + 1;
            getNewspapers(false);
        });
    }

}( jQuery ));

$(function() {
    if ($('#js-news').length) {
        $('#js-news').news();
    }
});
